import React from "react"

import { Grid } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import { Portlet } from "@/components"

const TrackableLinkMetricsSkeleton: React.FC = () => {
	return (
		<Grid
			container
			direction="column"
			spacing={5}
		>
			<Grid item>
				<Skeleton width={400} height={30} />
			</Grid>
			<Grid item>
				<Grid container direction="column" spacing={1}>
					<Grid item>
						<Grid container justifyContent="space-between" alignItems="center" spacing={2}>
							<Grid item>
								<Skeleton width={400} height={80} />
							</Grid>
							<Grid item>
								<Skeleton width={40} height={60} />
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Skeleton width={300} height={20} />
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<Skeleton height={150} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
					<Grid item xs={4}>
						<Skeleton height={150} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
					<Grid item xs={4}>
						<Skeleton height={150} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Grid
					container
					direction="column"
					spacing={3}
				>
					<Grid item>
						<Skeleton width={200} height={32} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
					<Grid item>
						<Portlet>
							<Grid container direction="column" spacing={2}>
								<Grid item>
									<Grid container spacing={1}>
										<Grid item xs={4}>
											<Skeleton height={60} variant="rect" style={{ borderRadius: 4 }} />
										</Grid>
										<Grid item xs={2}>
											<Skeleton width={100} height={60} variant="rect" style={{ borderRadius: 4 }} />
										</Grid>
									</Grid>
								</Grid>
								<Grid item>
									<Skeleton height={300} style={{ borderRadius: 4 }} variant="rect" />
								</Grid>
							</Grid>
						</Portlet>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default TrackableLinkMetricsSkeleton
